export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完成交易后，它将被关闭。内部资金将转移给用户。"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您确定要完成交易吗？"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是的，完成"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不，保持活跃"])}
}